/**
 * Default Document & Page Settings Configuration
 */

export interface DocumentDefaultsConfig {
  paperSize: 'A4' | 'Letter' | 'Legal';
  fontFamily: string;
  fontSizePt: number;
  lineSpacing: number;
  marginsMm: {
    top: number;
    bottom: number;
    left: number;
    right: number;
  };
  supportedPaperSizes: Array<{ id: 'A4' | 'Letter' | 'Legal'; label: string; widthMm: number; heightMm: number }>;
  supportedFonts: Array<{ id: string; label: string; category: 'Serif' | 'Sans-Serif' | 'Monospace' }>;
}

export const DOCUMENT_DEFAULTS: DocumentDefaultsConfig = {
  paperSize: 'A4',
  fontFamily: 'Times New Roman',
  fontSizePt: 12,
  lineSpacing: 1.5,
  marginsMm: {
    top: 25.4,    // 1.0 inch
    bottom: 25.4, // 1.0 inch
    left: 25.4,   // 1.0 inch
    right: 25.4,  // 1.0 inch
  },
  supportedPaperSizes: [
    { id: 'A4', label: 'A4 (210 × 297 mm)', widthMm: 210, heightMm: 297 },
    { id: 'Letter', label: 'US Letter (8.5 × 11 in)', widthMm: 215.9, heightMm: 279.4 },
    { id: 'Legal', label: 'US Legal (8.5 × 14 in)', widthMm: 215.9, heightMm: 355.6 },
  ],
  supportedFonts: [
    { id: 'Times New Roman', label: 'Times New Roman (Academic Standard)', category: 'Serif' },
    { id: 'Inter', label: 'Inter (Modern Sans)', category: 'Sans-Serif' },
    { id: 'Computer Modern', label: 'Computer Modern (LaTeX Style)', category: 'Serif' },
    { id: 'Arial', label: 'Arial (Clean Sans)', category: 'Sans-Serif' },
    { id: 'JetBrains Mono', label: 'JetBrains Mono (Code/Technical)', category: 'Monospace' },
  ],
};
